"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isContentClientConfigV2Fresh = exports.isContentClientConfigV2 = exports.isContentClientConfigV1 = void 0;
/**
 * Whether content client config is for Content Delivery v1
 * @param config
 * @hidden
 */
function isContentClientConfigV1(config) {
    return config.account !== undefined;
}
exports.isContentClientConfigV1 = isContentClientConfigV1;
/**
 * Whether content client config is for Content Delivery v2
 * @param config
 * @hidden
 */
function isContentClientConfigV2(config) {
    return config.hubName !== undefined;
}
exports.isContentClientConfigV2 = isContentClientConfigV2;
/**
 * Whether content client config is for Content Delivery v2 Fresh
 * @param config
 * @hidden
 */
function isContentClientConfigV2Fresh(config) {
    return (isContentClientConfigV2(config) &&
        config.apiKey !== undefined);
}
exports.isContentClientConfigV2Fresh = isContentClientConfigV2Fresh;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvbGliL2NvbmZpZy9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFzQkE7Ozs7R0FJRztBQUNILFNBQWdCLHVCQUF1QixDQUNyQyxNQUFrQztJQUVsQyxPQUFRLE1BQWdDLENBQUMsT0FBTyxLQUFLLFNBQVMsQ0FBQztBQUNqRSxDQUFDO0FBSkQsMERBSUM7QUFFRDs7OztHQUlHO0FBQ0gsU0FBZ0IsdUJBQXVCLENBQ3JDLE1BQWtDO0lBRWxDLE9BQVEsTUFBZ0MsQ0FBQyxPQUFPLEtBQUssU0FBUyxDQUFDO0FBQ2pFLENBQUM7QUFKRCwwREFJQztBQUVEOzs7O0dBSUc7QUFDSCxTQUFnQiw0QkFBNEIsQ0FDMUMsTUFBa0M7SUFFbEMsT0FBTyxDQUNMLHVCQUF1QixDQUFDLE1BQU0sQ0FBQztRQUM5QixNQUFxQyxDQUFDLE1BQU0sS0FBSyxTQUFTLENBQzVELENBQUM7QUFDSixDQUFDO0FBUEQsb0VBT0MifQ==